import ApiClient from '../ApiClient';

class CopilotRoutines extends ApiClient {
  constructor() {
    super('copilot/routines', { accountScoped: true });
  }
}

export default new CopilotRoutines();
